
(function () {
    'use strict';

    function initBuildYourRoutine(root) {
        var dataEl = root.querySelector('[data-byr-products]');
        if (!dataEl) return;

        var allProducts = [];
        try {
            allProducts = JSON.parse(dataEl.textContent || '[]');
        } catch (e) {
            console.error('Build Your Routine: could not parse product data', e);
            return;
        }
        // Only ever work with available products.
        allProducts.forEach(function (p) { p.tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); }); });

        var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
        var cartUrl = root.getAttribute('data-cart-url') || '/cart';
        var tier2 = parseFloat(root.getAttribute('data-tier-2-percent') || '10');
        var tier3 = parseFloat(root.getAttribute('data-tier-3-percent') || '15');

        function formatMoney(cents) {
            var value = (cents / 100).toFixed(2);
            return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
        }

        function showToast(msg) {
            var toast = root.querySelector('.byr-toast');
            if (!toast) return;
            toast.textContent = msg;
            toast.classList.add('is-visible');
            clearTimeout(toast._t);
            toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
        }

        /* -----------------------------------------------------------
           MODE TOGGLE
        ----------------------------------------------------------- */
        var modeBtns = root.querySelectorAll('[data-byr-mode-btn]');
        var panels = root.querySelectorAll('[data-byr-panel]');
        modeBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var mode = btn.getAttribute('data-byr-mode-btn');
                modeBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
                panels.forEach(function (p) {
                    p.classList.toggle('is-active', p.getAttribute('data-byr-panel') === mode);
                });
            });
        });

        /* -----------------------------------------------------------
           SHARED: cart add
        ----------------------------------------------------------- */
        function addItemsToCart(items, btn) {
            if (!items.length) return;
            var originalText = btn ? btn.textContent : '';
            if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: items })
            })
                .then(function (res) {
                    if (!res.ok) return res.json().then(function (err) { throw err; });
                    return res.json();
                })
                .then(function () {
                    showToast('Added to your cart ✓');
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                    document.dispatchEvent(new CustomEvent('cart:build-your-routine:added', { detail: { items: items } }));
                    if (btn) {
                        btn.textContent = 'Added ✓';
                        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800);
                    }
                })
                .catch(function (err) {
                    console.error('Build Your Routine: cart add failed', err);
                    showToast((err && err.description) || 'Something went wrong adding to cart.');
                    if (btn) { btn.disabled = false; btn.textContent = originalText; }
                });
        }

        /* -----------------------------------------------------------
           QUIZ
        ----------------------------------------------------------- */
        var quizRoot = root.querySelector('[data-byr-quiz]');
        if (quizRoot) {
            var steps = Array.prototype.slice.call(quizRoot.querySelectorAll('[data-byr-step]'));
            var resultsCount = parseInt(root.getAttribute('data-quiz-results-count') || '3', 10);
            var progressFill = quizRoot.querySelector('[data-byr-progress-fill]');
            var progressLabel = quizRoot.querySelector('[data-byr-progress-label]');
            var nextBtn = quizRoot.querySelector('[data-byr-next]');
            var backBtn = quizRoot.querySelector('[data-byr-back]');
            var resultsPanel = quizRoot.querySelector('[data-byr-results]');
            var resultsGrid = quizRoot.querySelector('[data-byr-results-grid]');
            var resultsTotalEl = quizRoot.querySelector('[data-byr-results-total]');
            var restartBtn = quizRoot.querySelector('[data-byr-restart]');
            var quizAddBtn = quizRoot.querySelector('[data-byr-quiz-add]');

            var currentStep = 0;
            var answers = {}; // stepIndex -> [tags]
            var quizSelectedIds = {}; // productId -> {product, qty}

            function updateProgress() {
                var pct = Math.round(((currentStep) / steps.length) * 100);
                if (progressFill) progressFill.style.width = pct + '%';
                if (progressLabel) progressLabel.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;
            }

            function showStep(index) {
                steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
                if (resultsPanel) resultsPanel.classList.remove('is-active');
                quizRoot.querySelector('[data-byr-steps]').style.display = '';
                updateProgress();
                if (backBtn) backBtn.hidden = index === 0;
                refreshNextState();
            }

            function refreshNextState() {
                var step = steps[currentStep];
                var required = step.getAttribute('data-required') !== 'false';
                var hasAnswer = !!(answers[currentStep] && answers[currentStep].length);
                if (nextBtn) nextBtn.disabled = required && !hasAnswer;
                if (nextBtn) nextBtn.textContent = currentStep === steps.length - 1 ? 'See My Routine' : 'Next';
            }

            steps.forEach(function (step, index) {
                var multi = step.getAttribute('data-multi') === 'true';
                var options = step.querySelectorAll('.byr-option');
                options.forEach(function (opt) {
                    var input = opt.querySelector('input');
                    opt.addEventListener('click', function () {
                        if (multi) {
                            input.checked = !input.checked;
                            opt.classList.toggle('is-selected', input.checked);
                        } else {
                            options.forEach(function (o) {
                                o.classList.remove('is-selected');
                                o.querySelector('input').checked = false;
                            });
                            input.checked = true;
                            opt.classList.add('is-selected');
                        }
                        var tags = [];
                        options.forEach(function (o) {
                            if (o.querySelector('input').checked) tags.push(o.getAttribute('data-tag'));
                        });
                        answers[index] = tags;
                        refreshNextState();
                    });
                });
            });

            function computeResults() {
                var chosenTags = [];
                Object.keys(answers).forEach(function (k) { chosenTags = chosenTags.concat(answers[k] || []); });
                chosenTags = chosenTags.filter(Boolean);

                var scored = allProducts.map(function (p) {
                    var score = p.tags.filter(function (t) { return chosenTags.indexOf(t) !== -1; }).length;
                    return { product: p, score: score };
                }).filter(function (s) { return s.score > 0 && s.product.available; });

                scored.sort(function (a, b) { return b.score - a.score; });

                var top = scored.slice(0, resultsCount).map(function (s) { return s.product; });

                // Fallback: not enough matches, fill with other available products.
                if (top.length < Math.min(2, resultsCount)) {
                    var fillers = allProducts.filter(function (p) {
                        return p.available && top.indexOf(p) === -1;
                    }).slice(0, resultsCount - top.length);
                    top = top.concat(fillers);
                }
                return top;
            }

            function renderResults() {
                var results = computeResults();
                quizSelectedIds = {};
                results.forEach(function (p) { quizSelectedIds[p.id] = { product: p, qty: 1 }; });

                resultsGrid.innerHTML = '';
                results.forEach(function (p) {
                    resultsGrid.appendChild(buildProductCard(p, quizSelectedIds, renderQuizTotal, true));
                });

                quizRoot.querySelector('[data-byr-steps]').style.display = 'none';
                resultsPanel.classList.add('is-active');
                renderQuizTotal();
            }

            function renderQuizTotal() {
                var count = 0, total = 0;
                Object.keys(quizSelectedIds).forEach(function (id) {
                    var entry = quizSelectedIds[id];
                    count += entry.qty;
                    total += entry.qty * entry.product.price;
                });
                if (resultsTotalEl) {
                    resultsTotalEl.innerHTML = count
                        ? formatMoney(total) + '<small>' + count + ' item' + (count > 1 ? 's' : '') + ' in this routine</small>'
                        : '<small>Select at least one product to continue</small>';
                }
                if (quizAddBtn) quizAddBtn.disabled = count === 0;
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', function () {
                    if (currentStep < steps.length - 1) {
                        currentStep++;
                        showStep(currentStep);
                    } else {
                        renderResults();
                    }
                });
            }
            if (backBtn) {
                backBtn.addEventListener('click', function () {
                    if (currentStep > 0) { currentStep--; showStep(currentStep); }
                });
            }
            if (restartBtn) {
                restartBtn.addEventListener('click', function () {
                    currentStep = 0;
                    answers = {};
                    steps.forEach(function (step) {
                        step.querySelectorAll('.byr-option').forEach(function (o) {
                            o.classList.remove('is-selected');
                            o.querySelector('input').checked = false;
                        });
                    });
                    showStep(0);
                });
            }
            if (quizAddBtn) {
                quizAddBtn.addEventListener('click', function () {
                    var items = Object.keys(quizSelectedIds).map(function (id) {
                        var entry = quizSelectedIds[id];
                        return { id: entry.product.variant_id, quantity: entry.qty };
                    });
                    addItemsToCart(items, quizAddBtn);
                });
            }

            showStep(0);
        }

        /* -----------------------------------------------------------
           SHARED PRODUCT CARD BUILDER
           Used by both the quiz results grid and the manual builder.
        ----------------------------------------------------------- */
        function buildProductCard(product, selectionMap, onChange, startSelected) {
            var card = document.createElement('div');
            card.className = 'byr-card' + (product.available ? '' : ' is-unavailable');
            if (startSelected && product.available) card.classList.add('is-selected');

            var media = product.image
                ? '<div class="byr-card-media"><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>'
                : '<div class="byr-card-media"></div>';

            var priceHtml = '<span>' + formatMoney(Math.round(product.price)) + '</span>';
            if (product.compare_at_price && product.compare_at_price > product.price) {
                priceHtml += '<span class="compare">' + formatMoney(Math.round(product.compare_at_price)) + '</span>';
            }

            card.innerHTML =
                (product.available ? '' : '<span class="byr-badge-unavailable">Sold out</span>') +
                '<span class="byr-card-check">✓</span>' +
                media +
                '<div class="byr-card-title">' + escapeHtml(product.title) + '</div>' +
                '<div class="byr-card-price">' + priceHtml + '</div>' +
                '<div class="byr-card-qty">' +
                '<button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
                '<span data-qty-value>1</span>' +
                '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
                '</div>';

            var qtyValueEl = card.querySelector('[data-qty-value]');

            function setQty(q) {
                q = Math.max(1, Math.min(20, q));
                selectionMap[product.id].qty = q;
                qtyValueEl.textContent = q;
                onChange();
            }

            card.addEventListener('click', function (e) {
                if (!product.available) return;
                if (e.target.closest('[data-qty-minus]') || e.target.closest('[data-qty-plus]')) return;
                var isSelected = card.classList.toggle('is-selected');
                if (isSelected) {
                    selectionMap[product.id] = { product: product, qty: 1 };
                    qtyValueEl.textContent = '1';
                } else {
                    delete selectionMap[product.id];
                }
                onChange();
            });

            card.querySelector('[data-qty-minus]').addEventListener('click', function (e) {
                e.stopPropagation();
                setQty((selectionMap[product.id] ? selectionMap[product.id].qty : 1) - 1);
            });
            card.querySelector('[data-qty-plus]').addEventListener('click', function (e) {
                e.stopPropagation();
                setQty((selectionMap[product.id] ? selectionMap[product.id].qty : 1) + 1);
            });

            return card;
        }

        function escapeHtml(str) {
            var div = document.createElement('div');
            div.textContent = str || '';
            return div.innerHTML;
        }

        /* -----------------------------------------------------------
           MANUAL BUILDER
        ----------------------------------------------------------- */
        var builderRoot = root.querySelector('[data-byr-builder]');
        if (builderRoot) {
            var grid = builderRoot.querySelector('[data-byr-builder-grid]');
            var filterChips = builderRoot.querySelectorAll('[data-byr-filter]');
            var summaryList = builderRoot.querySelector('[data-byr-summary-list]');
            var summaryEmpty = builderRoot.querySelector('[data-byr-summary-empty]');
            var summaryTier = builderRoot.querySelector('[data-byr-summary-tier]');
            var summarySubtotal = builderRoot.querySelector('[data-byr-summary-subtotal]');
            var summarySavings = builderRoot.querySelector('[data-byr-summary-savings]');
            var summarySavingsRow = builderRoot.querySelector('[data-byr-summary-savings-row]');
            var summaryTotal = builderRoot.querySelector('[data-byr-summary-total]');
            var builderAddBtn = builderRoot.querySelector('[data-byr-builder-add]');
            var mobileBar = builderRoot.querySelector('[data-byr-mobile-bar]');
            var mobileBarText = builderRoot.querySelector('[data-byr-mobile-bar-text]');
            var mobileBarAddBtn = builderRoot.querySelector('[data-byr-mobile-bar-add]');

            var builderSelected = {};
            var activeFilter = 'all';

            function tierDiscountPercent(count) {
                if (count >= 3) return tier3;
                if (count === 2) return tier2;
                return 0;
            }

            function renderGrid() {
                grid.innerHTML = '';
                var visible = allProducts.filter(function (p) {
                    return activeFilter === 'all' || p.tags.indexOf(activeFilter) !== -1;
                });
                if (!visible.length) {
                    grid.innerHTML = '<p class="byr-loading-text">No products found for this filter.</p>';
                    return;
                }
                visible.forEach(function (p) {
                    var card = buildProductCard(p, builderSelected, renderSummary, false);
                    grid.appendChild(card);
                });
            }

            function renderSummary() {
                var ids = Object.keys(builderSelected);
                var count = 0, subtotal = 0;
                ids.forEach(function (id) {
                    var entry = builderSelected[id];
                    count += entry.qty;
                    subtotal += entry.qty * entry.product.price;
                });

                if (!ids.length) {
                    summaryEmpty.style.display = '';
                    summaryList.style.display = 'none';
                    builderRoot.querySelector('[data-byr-summary-totals]').style.display = 'none';
                    summaryTier.style.display = 'none';
                    builderAddBtn.disabled = true;
                    if (mobileBar) mobileBar.classList.remove('has-items');
                    return;
                }

                summaryEmpty.style.display = 'none';
                summaryList.style.display = '';
                builderRoot.querySelector('[data-byr-summary-totals]').style.display = '';
                builderAddBtn.disabled = false;

                summaryList.innerHTML = ids.map(function (id) {
                    var entry = builderSelected[id];
                    return '<li class="byr-summary-item">' +
                        '<span class="byr-summary-item-name">' + escapeHtml(entry.product.title) + ' × ' + entry.qty + '</span>' +
                        '<span class="byr-summary-item-price">' + formatMoney(Math.round(entry.product.price * entry.qty)) + '</span>' +
                        '</li>';
                }).join('');

                var pct = tierDiscountPercent(ids.length);
                var savings = Math.round(subtotal * (pct / 100));
                var finalTotal = subtotal - savings;

                if (pct > 0) {
                    summaryTier.style.display = '';
                    summaryTier.textContent = 'Routine discount applied: ' + pct + '% off (' + ids.length + '+ products).';
                } else {
                    summaryTier.style.display = '';
                    var toNext = 2 - ids.length;
                    summaryTier.textContent = toNext > 0
                        ? 'Add ' + toNext + ' more product' + (toNext > 1 ? 's' : '') + ' to unlock a routine discount.'
                        : '';
                }

                summarySubtotal.textContent = formatMoney(Math.round(subtotal));
                if (pct > 0) {
                    summarySavingsRow.style.display = '';
                    summarySavings.textContent = '−' + formatMoney(Math.round(savings));
                } else {
                    summarySavingsRow.style.display = 'none';
                }
                summaryTotal.textContent = formatMoney(Math.round(finalTotal));

                if (mobileBar) {
                    mobileBar.classList.add('has-items');
                    mobileBarText.innerHTML = count + ' item' + (count > 1 ? 's' : '') + '<small>' + formatMoney(Math.round(finalTotal)) + '</small>';
                }
            }

            filterChips.forEach(function (chip) {
                chip.addEventListener('click', function () {
                    activeFilter = chip.getAttribute('data-byr-filter');
                    filterChips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
                    renderGrid();
                });
            });

            function addBuilderItemsToCart(btn) {
                var items = Object.keys(builderSelected).map(function (id) {
                    var entry = builderSelected[id];
                    return { id: entry.product.variant_id, quantity: entry.qty };
                });
                addItemsToCart(items, btn);
            }

            if (builderAddBtn) builderAddBtn.addEventListener('click', function () { addBuilderItemsToCart(builderAddBtn); });
            if (mobileBarAddBtn) mobileBarAddBtn.addEventListener('click', function () { addBuilderItemsToCart(mobileBarAddBtn); });

            renderGrid();
            renderSummary();
        }
    }

    function boot() {
        document.querySelectorAll('[data-byr-root]').forEach(initBuildYourRoutine);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    // Re-init if the section is reloaded by the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (e) {
        var newRoot = e.target.querySelector('[data-byr-root]');
        if (newRoot) initBuildYourRoutine(newRoot);
    });
})();
